import React from "react";
import "./Loading.css";

const Loading = ({ msg }) => {
  return (
    <div className="h-screen w-full flex justify-center items-center">
      <div className="flex flex-col h-screen w-full justify-center items-center ">
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p className="text-sm">{msg}</p>
      </div>
    </div>
  );
};

export default Loading;
